import {
    CORE_LOAD_ALL_HOLIDAYS_REQUEST,
    CORE_LOAD_ALL_HOLIDAYS_SUCCESS,

    CORE_LOAD_HOLIDAY_REQUEST,
    CORE_LOAD_HOLIDAY_SUCCESS
} from '../../types'


const initialState = []
export default {
    holidays: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_HOLIDAYS_REQUEST:
                return initialState
            case CORE_LOAD_ALL_HOLIDAYS_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    holiday: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_HOLIDAY_REQUEST:
                return initialState
            case CORE_LOAD_HOLIDAY_SUCCESS:
                return action.payload
            default:
                return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/features/holidays/reducer.js